<template>
    <v-container>
        <div id="carousel">
            <br>
            <v-layout>
                <v-flex xs12 sm12>
                    <div align="center">
                        <button @click="changeCarouselForward"><img src="../../../assets/backward.png"></button>
                        <button @click="changeCarouselBackward"><img src="../../../assets/forward.png"></button>
                    </div>
                </v-flex>
            </v-layout>
            <v-card class="mx-auto" v-if="carouselValue==1"
                    max-width="80%">
                <v-img class="white--text align-end"
                       height="200px"
                       src="https://www.techexplorist.com/wp-content/uploads/2019/12/hearing-loss.jpg">
                    <v-card-title>AUDITIVO</v-card-title>
                </v-img>
                <p class="pb-0">CONDICIÓN DE SALUD</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(1,'HISTORIA CLÍNICO-OCUPACIONAL AUDITIVO')" text>
                        HISTORIA CLÍNICO-OCUPACIONAL
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CONDICIÓN DE TRABAJO</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(2,'MEDICIONES AUDITIVO')" text>
                        MEDICIONES
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CRITERIOS FINALES</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(3,'CRITERIOS FINALES AUDITIVO')" text>
                        CRITERIOS FINALES
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card class="mx-auto" v-if="carouselValue==2"
                    max-width="80%">
                <v-img class="white--text align-end"
                       height="200px"
                       src="https://concepto.de/wp-content/uploads/2018/08/sistema-respiratorio-e1534864094153.jpg">
                    <v-card-title>RESPIRATORIO / TOXICOLOGÍA</v-card-title>
                </v-img>
                <p class="pb-0">CONDICIÓN DE SALUD</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(4,'APARATO RESPIRATORIO')" text>
                        HISTORIA CLÍNICA-LABORAL APARATO RESPIRATORIO
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CONDICIÓN DE TRABAJO</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(34, 'MEDICIONES RESPIRATORIO')" text>
                        MEDICIONES
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CRITERIOS FINALES</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(16,'CRITERIOS FINALES RESPIRATORIO')" text>
                        CRITERIOS
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card class="mx-auto" v-if="carouselValue==3"
                    max-width="80%">
                <v-img class="white--text align-end"
                       height="200px"
                       src="https://www.laboratuvar.com/images/Dermatolojik-Analizler-slider.jpg">
                    <v-card-title style="color: black">DERMATOLÓGICO / TOXICOLOGÍA</v-card-title>
                </v-img>
                <p class="pb-0">CONDICIÓN DE SALUD</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(5,'HISTORIA CLÍNICA LABORAL DERMATOLÓGICO')" text>
                        HISTORIA CLÍNICA LABORAL DERMATOLÓGICA
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange"
                           @click="openDialogForm(6,'DETERMINACIÓN DEL NIVEL DE EXPOSICIÓN DÉRMICA A SUSTANCIAS QUÍMICAS')"
                           text>
                        NGED
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CONDICIÓN DE TRABAJO</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(35, 'MEDICIONES')" text>
                        MEDICIONES
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CRITERIOS FINALES</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(17,'CRITERIOS FINALES DERMATOLÓGICO')" text>
                        CRITERIOS
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card class="mx-auto" v-if="carouselValue==4"
                    max-width="80%">
                <v-img class="white--text align-end"
                       height="200px"
                       src="https://blog.institutoisaf.es/hubfs/funciones-especificas-musculo-esqueletico-y-fibras-musculares.jpg">
                    <v-card-title>MUSCULOESQUELÉTICO</v-card-title>
                </v-img>
                <p class="pb-0">CONDICIÓN DE SALUD</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(7,'TRASTORNOS MUSCULOESQUELÉTICOS')" text>
                        TRASTORNOS MUSCULOESQUELÉTICOS
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(8,'QUICK DASH')" text>
                        QUICK DASH
                    </v-btn>
                    <v-btn color="orange" @click="openDialogForm(9,'ROLAND MORRIS')" text>
                        ROLAND MORRIS
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(10,'CUESTIONARIO NÓRDICO')" text>
                        CUESTIONARIO NÓRDICO
                    </v-btn>
                    <v-btn color="orange" @click="openDialogForm(11,'NDI')" text>
                        NDI
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(33,'PRUEBAS FUNCIONALES')" text>
                        PRUEBAS FUNCIONALES
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CONDICIÓN DE TRABAJO</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(30,'PLIBEL')" text>
                        PLIBEL
                    </v-btn>
                    <v-btn color="orange" @click="openDialogForm(31,'ISOTR12295')" text>
                        ISO/TR12295
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CRITERIOS FINALES</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(18,'CRITERIOS FINALES MUSCULOESQUELÉTICOS')" text>
                        CRITERIOS
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card class="mx-auto" v-if="carouselValue==5"
                    max-width="80%">
                <v-img class="white--text align-end"
                       height="200px"
                       src="data:image/jpeg;base64,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">
                    <v-card-title>OFTALMOLÓGICO</v-card-title>
                </v-img>
                <p class="pb-0">CONDICIÓN DE SALUD</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(14,'HISTORIA CLÍNICA-OCUPACIONAL OFTALMOLOGÍA')" text>
                        HISTORIA CLÍNICA-OCUPACIONAL OFTALMOLOGÍA
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(15,'CUESTIONARIO OSDI')" text>
                        OSDI
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CONDICIÓN DE TRABAJO</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(32,'ERGO')" text>
                        ERGO
                    </v-btn>
                    <v-btn color="orange" @click="openDialogForm(36,'MEDICIONES OFTALMOLÓGICO')" text>
                        MEDICIONES
                    </v-btn>
                </v-card-actions>
                <p class="pb-0">CRITERIOS FINALES</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(19,'CRITERIOS FINALES OFTALMOLÓGICO')" text>
                        CRITERIOS
                    </v-btn>
                </v-card-actions>
            </v-card>
            <v-card class="mx-auto" v-if="carouselValue==6"
                    max-width="80%">
                <v-img class="white--text align-end"
                       height="200px"
                       src="https://www.universidadviu.com/sites/universidadviu.com/files/images/educacion%20nutricional-min_0.jpg">
                    <v-card-title>NUTRICIONAL Y METABÓLICO</v-card-title>
                </v-img>
                <p class="pb-0">CONDICIÓN DE SALUD</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(20,'HISTORIA CLÍNICA NUTRICIONAL-METABÓLICA')" text>
                        HISTORIA CLÍNICA NUTRICIONAL-METABÓLICA
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(21,'SCORE SD METABÓLICO')" text>
                        SCORE SD METABÓLICO
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(22,'SCORE FRAMINGHAM')" text>
                        SCORE FRAMINGHAM
                    </v-btn>
                </v-card-actions>
                <!--<p class="pb-0">CRITERIOS FINALES</p>-->
                <!--<v-card-actions>-->
                <!--<v-btn color="orange" text>-->
                <!--CRITERIOS-->
                <!--</v-btn>-->
                <!--</v-card-actions>-->
            </v-card>
            <v-card class="mx-auto" v-if="carouselValue==7"
                    max-width="80%">
                <v-img class="white--text align-end"
                       height="200px"
                       src="https://www.sciencenewsforstudents.org/wp-content/uploads/2021/04/1030_neuron_explainer_feat.jpg">
                    <v-card-title>SALUD MENTAL</v-card-title>
                </v-img>
                <p class="pb-0">CONDICIÓN DE SALUD</p>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(12,'GHQ12( ANSIEDAD-DEPRESIÓN)')" text>
                        GHQ12( ANSIEDAD-DEPRESIÓN)
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(13,'Prueba Q 16')" text>
                        Prueba Q 16
                    </v-btn>
                </v-card-actions>
                <v-card-actions>
                    <v-btn color="orange" @click="openDialogForm(23,'SUSESO/ISTAS 21')" text>
                        SUSESO/ISTAS 21
                    </v-btn>

                </v-card-actions>
                <!--<p class="pb-0">CRITERIOS FINALES</p>-->
                <!--<v-card-actions>-->
                <!--<v-btn color="orange" text>-->
                <!--CRITERIOS-->
                <!--</v-btn>-->
                <!--</v-card-actions>-->
            </v-card>
        </div>
        <div id="loadData" style="display: none;">
            <v-card tile>
                <v-card-text overflow-y height="100%">
                    <v-toolbar card dark color="nav_background_color">
                        <v-btn icon dark @click.native="closeDialogForm">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{this.formName}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <monitoreo-auditivo v-if="formNumber==1"></monitoreo-auditivo>
                    <monitoreo-auditivo-medicion v-if="formNumber==2"></monitoreo-auditivo-medicion>
                    <monitoreo-auditivo-criterios-finales v-if="formNumber==3"></monitoreo-auditivo-criterios-finales>
                    <monitoreo-respiratorio-criterios-finales
                            v-if="formNumber==16"></monitoreo-respiratorio-criterios-finales>
                    <monitoreo-dermatologico-criterios-finales
                            v-if="formNumber==17"></monitoreo-dermatologico-criterios-finales>
                    <monitoreo-musculo-criterios-finales v-if="formNumber==18"></monitoreo-musculo-criterios-finales>
                    <monitoreo-oftalmologico-criterios-finales
                            v-if="formNumber==19"></monitoreo-oftalmologico-criterios-finales>
                    <plibel v-if="formNumber==30"></plibel>
                    <isotr12295 v-if="formNumber==31"></isotr12295>
                    <ergo v-if="formNumber==32"></ergo>
                    <pruebas-funcionales v-if="formNumber==33"></pruebas-funcionales>
                    <monitoreo-respiratorio-medicion v-if="formNumber==34"></monitoreo-respiratorio-medicion>
                    <monitoreo-dermatologico-medicion v-if="formNumber==35"></monitoreo-dermatologico-medicion>
                    <monitoreo-oftalmologico-medicion v-if="formNumber==36"></monitoreo-oftalmologico-medicion>
                    <monitoreo-dinamico v-if="formNumber>=4 && formNumber!=16 && formNumber!=17 && formNumber!=18
                                              && formNumber!=19 && formNumber!=30 && formNumber!=31 && formNumber!=32
                                              && formNumber!=33 && formNumber!=34 && formNumber!=35 && formNumber!=36"
                                        :number="formNumber">
                    </monitoreo-dinamico>
                </v-card-text>
            </v-card>
            <v-btn class="no-print" color="primary" @click="print" dark v-if="this.formNumber!=21 && this.formNumber!=22 && this.$store.state.routeSheet.status=='false'">Imprimir</v-btn>
        </div>
    </v-container>
</template>
<script>

    import MonitoreoAuditivo from "./MonitoreoAuditivo";
    import MonitoreoAuditivoMedicion from "./MonitoreoAuditivoMedicion";
    import MonitoreoAuditivoCriteriosFinales from "./criteriosFinales/MonitoreoAuditivoCriteriosFinales";
    import MonitoreoDinamico from "./MonitoreoDinamico";
    import MonitoreoRespiratorioCriteriosFinales from "./criteriosFinales/MonitoreoRespiratorioCriteriosFinales";
    import MonitoreoDermatologicoCriteriosFinales from "./criteriosFinales/MonitoreoDermatologicoCriteriosFinales";
    import MonitoreoMusculoCriteriosFinales from "./criteriosFinales/MonitoreoMusculoCriteriosFinales";
    import MonitoreoOftalmologicoCriteriosFinales from "./criteriosFinales/MonitoreoOftalmologicoCriteriosFinales";
    import Plibel from "../musculoEsqueletico/Plibel";
    import Isotr12295 from "../musculoEsqueletico/Isotr12295";
    import Ergo from "../oftalmologico/Ergo";
    import PruebasFuncionales from "../musculoEsqueletico/PruebasFuncionales";
    import MonitoreoRespiratorioMedicion from "./respiratorio/MonitoreoRespiratorioMedicion";
    import MonitoreoDermatologicoMedicion from "./dermatologico/MonitoreoDermatologicoMedicion";
    import MonitoreoOftalmologicoMedicion from "../oftalmologico/MonitoreoOftalmologicoMedicion.vue";

    export default {
        components: {
            MonitoreoAuditivo,
            MonitoreoAuditivoMedicion,
            MonitoreoAuditivoCriteriosFinales,
            MonitoreoDinamico,
            MonitoreoRespiratorioCriteriosFinales,
            MonitoreoDermatologicoCriteriosFinales,
            MonitoreoMusculoCriteriosFinales,
            MonitoreoOftalmologicoCriteriosFinales,
            Plibel,
            Isotr12295,
            Ergo,
            PruebasFuncionales,
            MonitoreoRespiratorioMedicion,
            MonitoreoDermatologicoMedicion,
            MonitoreoOftalmologicoMedicion
        },
        props: ['company'],
        data() {
            return {
                dialogForm: false,
                formNumber: "",
                formName: "",
                carouselValue: 1,
                monitoreoAuditivoCs: null,
                listMonitoreoAuditivoCs: [],
                radioGroup: 1,
                search: '',
                valid: false,
                requiredField: [v => !!v || 'Es requerido'],
                dialog: false,
            };
        },
        methods: {
            openDialogForm(number, name) {
                this.formNumber = number
                this.formName = name
                let carousel = document.getElementById("carousel");
                let loadData = document.getElementById("loadData");
                loadData.style.display = "block";
                carousel.style.display = "none";
            },

            changeCarouselForward() {
                if (this.carouselValue != 7) {
                    this.carouselValue = this.carouselValue + 1
                } else {
                    this.carouselValue = 1
                }
            },
            changeCarouselBackward() {
                if (this.carouselValue != 1) {
                    this.carouselValue = this.carouselValue - 1
                } else {
                    this.carouselValue = 7
                }
            },
            closeDialogForm() {
                this.formNumber = ""
                this.formName = ""
                let carousel = document.getElementById("carousel");
                let loadData = document.getElementById("loadData");
                loadData.style.display = "none";
                carousel.style.display = "block";
            },
            print(){
                this.$store.state.drawer = false
                this.$store.state.toolbar = false
                setTimeout(function(){
                    window.print()
                }, 1000);
                let self=this
                setTimeout(function(){
                    self.$store.state.toolbar = true
                }, 3000);
            }

        },
        computed: {},
        created() {
            this.$store.dispatch('getPatientFileByRouteSheets', this.$store.state.routeSheet.id).then(response => {

            }, error => {
                this.$store.state.progress = false;
                this.$store.state.dialogError = true;
            })
        }
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/patient/monitoreo/Carousel.vue